export const ORGANISATION = {
	GET_ALL_ORGANISATIONS: 'ORGANISATIONS_GET_ALL_ORGANISATIONS',
	SET_ALL_ORGANISATIONS: 'ORGANISATIONS_SET_ALL_ORGANISATIONS',
	GET_ALL_STATES: 'ORGANISATIONS_GET_ALL_STATES',
	SET_ALL_STATES: 'ORGANISATIONS_SET_ALL_STATES',
};
